<template>
  <div class="main-container" style="background-image: linear-gradient(#ffffff, #ebf3ff);">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'EmptyLayout',
  components: {
  },
}
</script>
